module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v(" STRANGE FIRE ")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("© 2013 by John MacArthur ")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published in Nashville, Tennessee, by Nelson Books, an imprint of Thomas Nelson. Nelson Books and Thomas Nelson are registered trademarks of HarperCollins Christian Publishing, Inc. ")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Thomas Nelson, Inc., titles may be purchased in bulk for educational, business, fund-raising, or sales promotional use. For information, please e-mail SpecialMarkets@ThomasNelson.com. ")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The websites recommended in this book are intended as resources for the reader. These websites are not intended in any way to be or to imply an endorsement on behalf of Thomas Nelson, nor does the publisher vouch for online content for the life of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Unleashing God’s Truth, One Verse at a Time® is a trademark of Grace to You. All rights reserved. ")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Unless otherwise indicated, Scripture quotations are taken from the THE NEW KING JAMES VERSION. © 1982 by Thomas Nelson, Inc. Used by permission. All rights reserved. ")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")]), _vm._v(" are taken from the NEW AMERICAN STANDARD BIBLE®, © The Lockman Foundation 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995. Used by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")]), _vm._v(" are taken from the Holy Bible, New International Version®. Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.™ Used by permission of Zondervan. All rights reserved worldwide. www.zondervan.com.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESV")]), _vm._v(" are taken from "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE ENGLISH STANDARD VERSION")]), _vm._v(". © 2001 by Crossway Bibles, a division of Good News Publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Italics added to Scripture quotations are the author’s own emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "isbn1"
  }, [_vm._v("ISBN: 978-1-4002-0641-4 (IE) ")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data ")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("MacArthur, John, 1939-")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Strange fire : the danger of offending the Holy Spirit with counterfeit worship / John MacArthur.")]), _vm._v(" "), _c('p', {
    staticClass: "crt3"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "isbn"
  }, [_vm._v("ISBN 978-1-4002-0517-2 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt4"
  }, [_vm._v("1. Holy Spirit. 2. Worship. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("BT123.M148 2013 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("231'.3--dc23 ")]), _vm._v(" "), _c('p', {
    staticClass: "other1"
  }, [_vm._v("2013015552 ")]), _vm._v(" "), _c('p', {
    staticClass: "printhistory"
  }, [_c('i', [_vm._v("Printed in the United States of America ")])]), _vm._v(" "), _c('p', {
    staticClass: "other"
  }, [_vm._v("13 14 15 16 17 RRD 6 5 4 3 2 1 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-851a313e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 66
// module chunks = 0